module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/ma-header-image-lg-1a2632355831efd2f820d3177b53e524.jpg";